const API_LINK = 'https://selector.pmcstore.net.au/api/';
// const API_LINK = 'http://192.168.0.105/eSelector%20(Zeeshan)/Dashboard/api/';
export default API_LINK;
